// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__MivEN","resendInfoText":"OnGoingPaymentBox_resendInfoText__1YG0c"};